var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 54,
    viewBox: "0 0 67 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.5H27",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8531 17.625H52.7219C47.1438 17.625 42.625 21.8219 42.625 27C42.625 32.1781 47.1469 36.375 52.7187 36.375H60.8531C61.1156 36.375 61.2438 36.375 61.3531 36.3688C63.0406 36.2656 64.3844 35.0187 64.4937 33.4531C64.5 33.3531 64.5 33.2312 64.5 32.9906V21.0094C64.5 20.7688 64.5 20.6469 64.4937 20.5469C64.3812 18.9813 63.0406 17.7344 61.3531 17.6312C61.2469 17.625 61.1156 17.625 60.8531 17.625Z",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2656 17.625C61.0219 11.775 60.2406 8.1875 57.7125 5.6625C54.0531 2 48.1594 2 36.375 2H27C15.2156 2 9.32187 2 5.6625 5.6625C2.00312 9.325 2 15.2156 2 27C2 38.7844 2 44.6781 5.6625 48.3375C9.325 51.9969 15.2156 52 27 52H36.375C48.1594 52 54.0531 52 57.7125 48.3375C60.2406 45.8125 61.025 42.225 61.2656 36.375",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9718 27H52.0037",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9f103d8df54f49c4dcdcfb09541b5aa2.svg";
export { ForwardRef as ReactComponent };